import { Cookie } from "@hooks/use-cookies";

export const COOKIE_MAX_AGE_SECONDS = 7884000;
export const COOKIE_DOMAIN = ".constellation.academy";

export const CAOptinCookie = Cookie.CAOptin;
